<template>
  <div class="list-container">
    <div class="filter-container">
        <div class="filter-box">
        <span class="label">业务编号</span>
        <el-input
          v-model="listQuery.businessNo"
          style="width: 200px"
          :size="t('table.btnSize')"
          class="filter-item"
          clearable
          @keyup.enter="handleFilter"
        />
      </div>
      <div class="filter-box">
        <span class="label">业务名称</span>
        <el-input
          v-model="listQuery.businessName"
          style="width: 200px"
          :size="t('table.btnSize')"
          class="filter-item"
          clearable
          @keyup.enter="handleFilter"
        />
      </div>
      <!-- <div class="filter-box">
        <span class="label">业务品牌</span>
        <el-input
          v-model="listQuery.businessBrand"
          style="width: 200px"
          :size="t('table.btnSize')"
          class="filter-item"
          clearable
          @keyup.enter="handleFilter"
        />
      </div>
      <div class="filter-box">
        <span class="label">业务型号</span>
        <el-input
          v-model="listQuery.businessModel"
          style="width: 200px"
          :size="t('table.btnSize')"
          class="filter-item"
          clearable
          @keyup.enter="handleFilter"
        />
      </div>
      <div class="filter-box">
        <span class="label">序列号</span>
        <el-input
          v-model="listQuery.businessSerial"
          style="width: 200px"
          :size="t('table.btnSize')"
          class="filter-item"
          clearable
          @keyup.enter="handleFilter"
        />
      </div> -->
      <div class="filter-box">
        <span class="label">材料编号</span>
        <el-input
          v-model="listQuery.materialNo"
          style="width: 200px"
          :size="t('table.btnSize')"
          class="filter-item"
          clearable
          @keyup.enter="handleFilter"
        />
      </div>
      <div class="filter-box">
        <span class="label">材料名称</span>
        <el-input
          v-model="listQuery.materialName"
          style="width: 200px"
          :size="t('table.btnSize')"
          class="filter-item"
          clearable
          @keyup.enter="handleFilter"
        />
      </div>
      <!-- <div class="filter-box">
        <span class="label">材料品牌</span>
        <el-input
          v-model="listQuery.materialBrand"
          style="width: 200px"
          :size="t('table.btnSize')"
          class="filter-item"
          clearable
          @keyup.enter="handleFilter"
        />
      </div> -->
      <div class="filter-box">
        <span class="label">材料型号</span>
        <el-input
          v-model="listQuery.materialModel"
          style="width: 200px"
          :size="t('table.btnSize')"
          class="filter-item"
          clearable
          @keyup.enter="handleFilter"
        />
      </div>
      <!-- <div class="filter-box">
        <span class="label">材料代码</span>
        <el-input
          v-model="listQuery.materialCode"
          style="width: 200px"
          :size="t('table.btnSize')"
          class="filter-item"
          clearable
          @keyup.enter="handleFilter"
        />
      </div> -->
      <div class="filter-box">
        <span class="label">采购状态</span>
        <el-select :filterable="true" v-model="listQuery.purchaseStatus" class="filter-item" placeholder="" clearable collapse-tags :size="t('table.btnSize')" @change="handleFilter">
          <el-option
            v-for="item in purchaseStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="filter-box">
        <span class="label">出库状态</span>
        <el-select :filterable="true" v-model="listQuery.status" class="filter-item" placeholder="" clearable collapse-tags :size="t('table.btnSize')" @change="handleFilter">
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="filter-box">
        <span class="label">开始日期</span>
        <el-date-picker
          v-model="listQuery.startTime"
          type="date"
          placeholder=" "
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          @change="handleFilter"
          :size="t('table.btnSize')"
        >
        </el-date-picker>
      </div>
      <div class="filter-box">
        <span class="label">结束日期</span>
        <el-date-picker
          v-model="listQuery.endTime"
          type="date"
          placeholder=" "
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          @change="handleFilter"
          :size="t('table.btnSize')"
        >
        </el-date-picker>
      </div>
      <div class="filter-box">
        <el-button
          v-waves
          class="filter-item "
          type="primary"
          :size="t('table.btnSize')"
          @click="handleFilter"
        >
          {{ t("table.search") }}
        </el-button>
        <el-button
          v-waves
          class="filter-item"
          :size="t('table.btnSize')"
          @click="handleReset"
        >
          {{ t("table.reset") }}
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          :size="t('table.btnSize')"
          @click="handleCommand('office-apply')"
        >
          申请办公用品
        </el-button>
        <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
          <i class="icon-tubiao-27 iconfont"/>
        </span>
        <span class="svg-icon cursor" @click="handleCommand('column')">
          <i class="icon-tubiao-28 iconfont"/>
        </span>
        <span class="ml-10 filter-mark">
          <span class="status-item"><span class="status-square" style="background-color: red;"></span><span class="status-text">待定（无需采购/已入库）</span></span>
          <span class="status-item"><span class="status-square" style="background-color: blue;"></span><span class="status-text">待定（需采购且未入库）</span></span>
        </span>
      </div>
    </div>
    <TableList
      ref="tableListRef"
      v-loading="listLoading"
      :dataList="list"
      :total="total"
      :columnAllData="columnAllData"
      :tableName="TableName"
      :page="listQuery.page"
      :size="listQuery.size"
      :canRefresh="false"
      :canChangeColumn="false"
      :showSummary="true"
      :tableRowClassName="tableRowClassName"
      @command-change="handleCommand"
    >
     <template v-slot:operation-action="scope">
        <el-link
         v-if="(scope.row.purchaseStatusValue === '无需采购' || scope.row.purchaseStatusValue === '已入库') && scope.row.statusValue === '待定'"
          href="javascript:void(0);"
          class="mr-10"
          type="primary"
          @click="handleCommand('deliver-comfirm', scope.row)"
        >
          出库
        </el-link>
      </template>
    </TableList>
     <el-dialog
      v-model="deliverVisible"
      title="出库"
      width="70%"
    >
    <div class="form-title mb-10 mt-10">
      <span class="left">物料信息</span>
    </div>
    <el-descriptions >
      <el-descriptions-item label="物料编号：">{{activeRow.material.no}}</el-descriptions-item>
      <el-descriptions-item label="物料名称：">{{activeRow.material.name}}</el-descriptions-item>
      <el-descriptions-item label="物料型号：">{{activeRow.material.model}}</el-descriptions-item>
      <el-descriptions-item label="物料单位：">{{activeRow.material.materialUnit}}</el-descriptions-item>
      <el-descriptions-item label="物料类别：">{{activeRow.materialClass}}</el-descriptions-item>
      <el-descriptions-item label="数量：">{{activeRow.num}}</el-descriptions-item>
    </el-descriptions>
      <el-form
        ref="dataForm"
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="mb-20"
      >
        <div class="underlineForm">
          <el-form-item label="数量" prop="num">
            <el-input v-model="ruleForm.num" type="number" :min="0" :max="activeRow.num"></el-input>
          </el-form-item>
          <el-form-item label="位置" prop="locationId">
            <el-select :filterable="true" v-model="ruleForm.locationId" class="filter-item" placeholder="输入关键字搜索" clearable :size="t('table.btnSize')">
              <el-option
                v-for="item in locationOption"
                :key="item.locationId"
                :label="item.location?.location"
                :value="item.locationId"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="dialog-footer mt-20 " style="text-align:right">
          <el-button @click="deliverVisible = false" >
            {{ t("table.cancel") }}
          </el-button>
          <el-button
            type="primary"
            @click="handleDeliverComfirm()"
          >
            {{ t("table.confirm") }}
          </el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      v-model="officeDeliverVisible"
      title="申请办公用品"
      width="80%"
      destroy-on-close
    >
      <FormDeliver :id="null" type="OFFICE" @update:visibel="officeDeliverVisible = false" @submit="getList" />
    </el-dialog>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref, unref } from 'vue'
import { PaymentAccountModel, ArrayRowsItem } from '@/model/Index'
import { ElMessage, ElForm } from 'element-plus'
import { getPageList } from '@/apis/Form'
import TableList from '@/components/common/TableList.vue'
import FormDeliver from '@/views/repair/FormDeliver.vue'
import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'
import { pageVo, defaultDate } from '@/utils/index'
import { putUrl } from '@/apis/Dictionary'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'PurchaseMine',
  components: {
    TableList,
    FormDeliver
  },
  setup() {
    const { t } = useI18n()
    const dataForm = ref(ElForm)

    const tableListRef = ref(null)
    const dataMap = reactive({
      TableName: TableName.TABLE_PURCHASE_MINE,
      permissionName: permissionName.COMPANYTYPE,
      columnAllData: TableField,
      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        brand: undefined,
        model: undefined,
        serial: undefined,
        type: undefined,
        urgentId: undefined,
        customerCompanyName: undefined,
        customerCompanyContactName: undefined,
        customerCompanyContactPhone: undefined,
        salesManId: undefined,
        engineerId: undefined,
        outsourceCompanyName: undefined,
        outsourceCompanyContactName: undefined,
        outsourceCompanyContactPhone: undefined,
        startTime: '',
        endTime: '',
        status: undefined,
        purchaseStatus: undefined,
        ...pageVo
      },
      purchaseStatusOptions: [
        { label: '无需采购', value: 0 },
        { label: '拒绝采购', value: 1 },
        { label: '生成采购单', value: 2 },
        { label: '已入库', value: 4 }
      ],
      statusOptions: [
        { label: '待定', value: 0 },
        { label: '待确认', value: 1 },
        { label: '已确认', value: 2 }
      ],
      deliverVisible: false,
      officeDeliverVisible: false,
      materialId: 0 as any,
      activeRow: {} as any,
      locationOption: [],
      ruleForm: {
        num: null,
        locationId: null
      },
      rules: {
        locationId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        num: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      getList() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        dataMap.listLoading = true
        getPageList('storage/my/materialDeliveryDetail', dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data
            ? res.data.map((item: any) => {
              const temp = item
              if (item.business) {
                Object.assign(temp, {
                  businessNo: item.business.no,
                  businessName: item.business.name,
                  businessBrand: item.business.brand,
                  businessAmount: item.business.amount,
                  businessModel: item.business.model,
                  businessSerial: item.business.serial
                })
              }
              if (item.material) {
                Object.assign(temp, {
                  materialNo: item.material.no,
                  materialClass: item.material.materialClass,
                  materialUnit: item.material.materialUnit,
                  materialStandard: item.material.standard,
                  materialId: item.material.id,
                  materialBrand: item.material.brand,
                  materialName: item.material.name,
                  materialModel: item.material.model,
                  materialCode: item.material.code,
                  materialParameter: item.material.parameter,
                  materialDevice: item.material.device,
                  materialMark: item.material.mark
                })
              }
              if (item.location) {
                Object.assign(temp, {
                  locationFull: item.location.location
                })
              }
              return temp
            })
            : []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'deliver-comfirm':
            dataMap.activeRow = val
            dataMap.materialId = val.materialId
            dataMap.getLocationOption()
            dataMap.ruleForm = {
              num: dataMap.activeRow.num,
              locationId: null
            }
            dataMap.deliverVisible = true
            break
          case 'office-apply':
            dataMap.officeDeliverVisible = true
            break
        }
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          brand: undefined,
          model: undefined,
          serial: undefined,
          type: undefined,
          urgentId: undefined,
          customerCompanyName: undefined,
          customerCompanyContactName: undefined,
          customerCompanyContactPhone: undefined,
          salesManId: undefined,
          engineerId: undefined,
          outsourceCompanyName: undefined,
          outsourceCompanyContactName: undefined,
          outsourceCompanyContactPhone: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: undefined,
          purchaseStatus: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getLocationOption() {
        getPageList(`storage/storage/${dataMap.materialId}`).then((res: any) => {
          dataMap.locationOption = res || []
          dataMap.ruleForm.locationId = res[0]?.locationId
        })
      },
      handleDeliverComfirm() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            const params = {
              materialId: dataMap.activeRow.id,
              ...dataMap.ruleForm
            }
            if (!params.num) {
              return ElMessage.error('数量不得为0！')
            }
            if (Number(params.num) > dataMap.activeRow.num) {
              return ElMessage.error('数量不得大于原本数量！')
            }
            putUrl(`storage/completionMaterialDelivery/${dataMap.activeRow.id}`, params).then((response) => {
              dataMap.getList()
              dataMap.deliverVisible = false
              if (response.hasPurchase) {
                ElMessage.info('库存不足，将自动生成预采购单！')
              } else {
                ElMessage({
                  message: '出库成功',
                  type: 'success',
                  duration: 2000
                })
              }
            })
          }
        })
      },
      tableRowClassName({ row }: any) {
        const { statusValue, purchaseStatusValue } = row
        if (statusValue === '待定') {
          if (['无需采购', '已入库'].includes(purchaseStatusValue)) {
            return 'row-red'
          } else {
            return 'row-blue'
          }
        }
        return ''
      }
    })
    onMounted(() => {
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap), tableListRef, dataForm }
  }
})
</script>
<style  lang="scss">

</style>
